module.exports = __webpack_public_path__ + "img/dt_x.cd1ad14a.png";